/** Till picker: mall, then a brand present in that mall. Remembered per device. */
import { errorBox, field, h } from "../dom-helpers";
import type { RenderedScreen, ScannerApp } from "../scanner-app-context";
import { strings } from "../strings";
import { saveTill } from "../till-selection-store";

export function renderTillPicker(app: ScannerApp): RenderedScreen {
  const error = errorBox();
  const mall = h("select", { name: "mall", required: true });
  const brand = h("select", { name: "brand", required: true });

  const placeholder = () => h("option", { value: "" }, strings.tillChoose);
  mall.append(placeholder(), ...app.malls.map((m) => h("option", { value: m.id }, m.name)));

  const fillBrands = () => {
    const selectedMall = app.malls.find((m) => m.id === mall.value);
    const available = selectedMall ? app.brands.filter((b) => selectedMall.brandIds.includes(b.id)) : [];
    brand.replaceChildren(placeholder(), ...available.map((b) => h("option", { value: b.id }, b.name)));
    if (app.till && available.some((b) => b.id === app.till?.brandId)) brand.value = app.till.brandId;
    brand.disabled = available.length === 0;
  };
  mall.addEventListener("change", fillBrands);
  if (app.till) mall.value = app.till.mallId;
  fillBrands();

  const form = h(
    "form",
    {
      className: "card stack",
      onsubmit: (event: Event) => {
        event.preventDefault();
        if (!mall.value || !brand.value) {
          error.show(strings.tillChoose);
          return;
        }
        app.till = saveTill(brand.value, mall.value);
        app.refreshHeader();
        app.navigate({ name: "scan" });
      },
    },
    h("h2", {}, strings.tillTitle),
    app.malls.length === 0 ? h("p", { className: "error", role: "alert" }, strings.tillLoadFailed) : null,
    field(strings.tillMall, mall),
    field(strings.tillBrand, brand),
    error.el,
    h("button", { type: "submit", className: "primary" }, strings.tillSave),
  );
  return { el: form };
}
